import React from 'react'
import MyPayroll from './MyPayroll'


export default function ViewAssignmentReport() {
  return (
    <div>
      <MyPayroll />
    </div>
  )
}
